import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';

class HeUpload extends ChemComponent {
  	constructor(props) {
		super(props);
				
		this.state = {
			renderKey: 1,
			upload: {
				FILE: null
			}
		};
	}
	
	onChangeSearch(accessor, value) {
		var upload = this.copyObject(this.state.upload);
		this.setByAccessor(upload, accessor, value);
		this.mergeState({ upload: upload });
	}
	
	onSubmitSearch(event) {
		var self = this;
		
		// get file from state
		var upload = this.state.upload.FILE;
		
		// if there is an upload file
		if (upload && upload.name) {
			// Create an object of formData
			const formData = new FormData();

			// add the token to the formData
			formData.append("__RequestVerificationToken", this.props.user.antiForgeryToken);
		
			// add the upload file
			formData.append("he", upload, upload.name);
			
			this.ajax({
				type: 'POST',
				url: this.getConfig().host + '/HeLAD/UploadHe',
				overlay: true,
				data: formData,
				contentType: false,
				processData: false
			}).done(function (data) {
				if (data.Success) {
					self.showConfirmation(() => {
						return (<>
							{data.LinesUploaded} Lines uploaded.<br />
							<Link to={'/HeLAD/HeMeterReadings'}>View meter readings</Link>
						</>);
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {
		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Uploads</span>
					<ChemEdit parent={this} columns={uploadColumns} data={this.state.upload} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={12}>
						  <Button id="upload" variant="warning" type="submit" className="float-end">Upload xlsx file</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
			</Container>
		</>);
	}
}

const uploadColumns = [
	{ Header: 'File to Upload', accessor: 'FILE', type: 'file', required: true }
];

export default withRouter(HeUpload);